import request from '@/utils/request'


// 查询宠物档案列表
export function listPet(query) {
  return request({
    url: '/mibo/pet/list',
    method: 'get',
    params: query
  })
}

// 查询宠物档案分页
export function pagePet(query) {
  return request({
    url: '/mibo/pet/page',
    method: 'get',
    params: query
  })
}

// 查询宠物档案详细
export function getPet(data) {
  return request({
    url: '/mibo/pet/detail',
    method: 'get',
    params: data
  })
}

// 新增宠物档案
export function addPet(data) {
  return request({
    url: '/mibo/pet/add',
    method: 'post',
    data: data
  })
}

// 修改宠物档案
export function updatePet(data) {
  return request({
    url: '/mibo/pet/edit',
    method: 'post',
    data: data
  })
}

// 删除宠物档案
export function delPet(data) {
  return request({
    url: '/mibo/pet/delete',
    method: 'post',
    data: data
  })
}
